export type VariantSizes = 1 | 2 | 3;

export const variantShadow = '1px 1px 4px rgba(0, 0, 0, 0.2)';
